function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FijiFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#67BFE5",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "14",
        height: "11",
        x: "0",
        y: "3",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 3h13.5v10.5H0z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "m-1.503 12.75 2.97 1.303 12.1-9.636 1.567-1.937-3.176-.435-4.936 4.152L3.05 8.995l-4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m-1.097 13.663 1.514.756L14.572 2.3h-2.125L-1.096 13.663Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "m15.003 12.75-2.97 1.303-12.1-9.636-1.567-1.937 3.176-.435 4.936 4.152 3.972 2.798 4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m14.902 13.405-1.514.756-6.027-5.188-1.787-.58-7.36-5.906H.34l7.355 5.766 1.954.695 5.253 4.457Z"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "d",
          width: "16",
          height: "13",
          x: "-1",
          y: "2",
          fill: "#000",
          maskUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/_jsx("path", {
            fill: "#fff",
            d: "M-1 2h16v13H-1z"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
            clipRule: "evenodd"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          fillRule: "evenodd",
          d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "M5.988 3v-.75h-.75V3h.75Zm1.5 0h.75v-.75h-.75V3Zm-1.5 4.5v.75h.75V7.5h-.75ZM0 7.5v-.75h-.75v.75H0ZM0 9h-.75v.75H0V9Zm5.988 0h.75v-.75h-.75V9Zm0 4.5h-.75v.75h.75v-.75Zm1.5 0v.75h.75v-.75h-.75Zm0-4.5v-.75h-.75V9h.75ZM13.5 9v.75h.75V9h-.75Zm0-1.5h.75v-.75h-.75v.75Zm-6.012 0h-.75v.75h.75V7.5Zm-1.5-3.75h1.5v-1.5h-1.5v1.5Zm.75 3.75V3h-1.5v4.5h1.5ZM0 8.25h5.988v-1.5H0v1.5ZM.75 9V7.5h-1.5V9h1.5Zm5.238-.75H0v1.5h5.988v-1.5Zm.75 5.25V9h-1.5v4.5h1.5Zm.75-.75h-1.5v1.5h1.5v-1.5ZM6.738 9v4.5h1.5V9h-1.5Zm6.762-.75H7.488v1.5H13.5v-1.5Zm-.75-.75V9h1.5V7.5h-1.5Zm-5.262.75H13.5v-1.5H7.488v1.5ZM6.738 3v4.5h1.5V3h-1.5Z",
          mask: "url(#d)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M15 10.5h7.241v6.25s-.607 2.75-3.62 2.75C15.607 19.5 15 16.75 15 16.75V10.5Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("mask", {
        id: "e",
        width: "8",
        height: "10",
        x: "15",
        y: "10",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M15 10.5h7.241v6.25s-.607 2.75-3.62 2.75C15.607 19.5 15 16.75 15 16.75V10.5Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#e)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#C3352C",
          d: "M15 10.5h7.241v2.25H15z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#C3352C",
          d: "M18.104 12.5h1.034v7h-1.034z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#C3352C",
          fillRule: "evenodd",
          d: "M15 15.25h7.241v1H15v-1Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#979797",
          fillRule: "evenodd",
          d: "M16.905 18.553c.436.615.79.856 1.041.493.177-.255.195-.51-.056-.56a4.184 4.184 0 0 1-.308-.43l.009-.008c.07-.068.073-.16.06-.194-.006-.046.029-.11.255-.283.205-.157.296-.304.162-.466-.071-.086-.134-.103-.335-.134l-.061-.01a1.059 1.059 0 0 1-.13-.027l-.139-.266a1.717 1.717 0 0 0-.766.147l-.227.096a.912.912 0 0 1-.092.038l.003-.003c.006-.005.016-.012.002-.012-.053 0-.11-.006-.267-.026l-.03-.004c-.453-.057-.567-.055-.64.155-.111.321.55.909.9.98.176.035.386.203.62.514Zm.493-.442a.404.404 0 0 0 .104-.01l.009-.018a.196.196 0 0 1-.113.028Zm-1.652-.885c-.01-.01-.012-.025-.006-.043-.001.004.003.012.012.023l-.006.02Zm.044.024c.125.13.444.395.57.42.284.058.562.28.848.662.291.411.428.504.43.5.031-.045.045-.034.068-.015.019.015.043.035.086.035l-.146-.07a4.301 4.301 0 0 1-.414-.585c-.104-.195-.12-.39.054-.445.03-.13.127-.263.32-.421-.155-.026-.246-.052-.325-.113a.293.293 0 0 1-.111-.166 1.41 1.41 0 0 0-.387.108l-.226.096c-.17.072-.205.087-.207.083-.001-.001 0-.004.002-.006.005-.01.014-.024-.029-.024a2.38 2.38 0 0 1-.314-.03l-.03-.003a2.579 2.579 0 0 0-.064-.007.798.798 0 0 1-.125-.019Zm0 0a.091.091 0 0 1-.044-.024l.006-.02a.528.528 0 0 0 .038.044Zm1.485.645c.002-.002.002-.005.002-.008l-.003.008Zm.12-.159h-.012l.005.001h.006Zm.003 0h-.004Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#964C36",
          strokeWidth: ".5",
          d: "M16.241 15.083s-.358-.495-.358-.672"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#2A8E51",
          strokeWidth: ".5",
          d: "M16.02 14.657s-.458-.195-.458 0M16.012 14.452s-.322-.41-.564-.41c-.242 0-.236.205-.236.205M15.828 14.041s-.144-.67-.374-.67-.23.336-.23.336M15.886 14.04s-.064-.574.232-.574"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#964C36",
          strokeWidth: ".5",
          d: "M16.696 14.986s-.167-.588-.107-.754"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#2A8E51",
          strokeWidth: ".5",
          d: "M16.633 14.51s-.364-.34-.43-.156M16.696 14.314s-.163-.494-.39-.577c-.227-.083-.292.111-.292.111M16.663 13.866s.095-.678-.122-.757c-.216-.079-.33.236-.33.236M16.719 13.885s.136-.561.414-.46"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#964C36",
          strokeWidth: ".35",
          d: "M17.064 15.195s.237-.563.198-.735"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#2A8E51",
          strokeWidth: ".35",
          d: "M17.185 14.73s.402-.293.446-.102M17.146 14.529s.221-.472.457-.526c.236-.055.276.146.276.146M17.233 14.088s-.011-.685.213-.737c.224-.052.3.275.3.275M17.176 14.1s-.067-.574-.356-.508M20.023 14.851s.182-.835.698-.835c.517 0 .748.883.748.883"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#2A8E51",
          strokeWidth: ".35",
          d: "M19.597 14.281s.278-.493 1.196-.453c.918.04 1.085.453 1.085.453M19.412 13.654s.504-.624 1.21-.095l.24.095s.24-.708 1.4 0"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#964C36",
          strokeWidth: ".5",
          d: "M20.804 15.028s.037-.78.16-.994M21.824 16.735s-.464-.218-.602 0c-.139.218-1.81 2.222-1.81 2.222"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFF203",
          fillRule: "evenodd",
          d: "m20.223 16.946 1.036.724s.476-.34.238-.532-.887-.53-.887-.53l-.387.338Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#00A651",
          fillRule: "evenodd",
          d: "M20.187 16.983s-.24.252-.24.444-.223.706-.223.706.625.384.754.14c.13-.245.972-.099.823-.473-.148-.373-1.114-.817-1.114-.817Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD100",
          fillRule: "evenodd",
          d: "M15.792 11.387s.553-.284.827 0c.274.284.498-.024.498-.195s.435-.759.435-.282c0 .477-.136.746.246.746s2.103-.659 2.515-.464c.413.195.728.146.623-.133-.104-.28-.374-.454-.893-.301-.519.152-.396.301-.845.301-.448 0-.948-.149-.948-.149s.14-.25.653-.072c.512.178 1.218-.221 1.41-.221.192 0 .72-.012.773.14.053.153.372.293.129.435-.244.142-.645.231-.369.413.276.182.911.147.942.337.03.19.331.472.21.472-.12 0-.339.267-.542.186-.203-.082-.227-.153-.032-.219s.193-.342.032-.342c-.16 0-.082.097-.448 0s-.85-.205-.821 0c.029.204.267.519-.172.56-.44.043-.646.21-.731.075-.086-.135-.392-.316-.151-.373.24-.058.47.196.557.155.086-.042.283-.065.118-.241-.164-.176-.435-.28-.184-.412.251-.132.053-.134-.426.139s-.745.505-1.165.472c-.42-.033-.578.011-.713-.033-.136-.044-.794.49-.983.354-.19-.135-.801-.187-.691-.354.11-.166.258-.252.422-.166.165.085.329.171.44.085.11-.085.432-.38.351-.438-.08-.059-.003-.257-.46-.257-.456 0-.617.22-.725.082-.109-.139.118-.3.118-.3Z",
          clipRule: "evenodd"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Fiji.js.map